import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { NextEditorPlugin } from '@atlaskit/editor-common/types';

const pluginName = 'ssr-plugin';
const pmPluginName = 'ssr-disable-transactions';

export const ssrPlugin: NextEditorPlugin<typeof pluginName> = () => {
	return {
		name: pluginName,
		pmPlugins() {
			return [
				{
					name: pmPluginName,
					plugin() {
						return new SafePlugin({
							filterTransaction() {
								// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
								return !process.env.REACT_SSR;
							},
						});
					},
				},
			];
		},
	};
};
